import { Attachment } from '../../../../@types/types'
import { AttachmentType as AiAttachmentType } from '../../../../api/aiDataExtraction/types'
import { AiUploadedImage } from './AiUploadImageSection'

export type UploadedAttachmentState = {
  status: 'uploading' | 'uploaded' | 'failed'
  attachment?: Attachment
}

export const getAttachmentsForExtraction = (
  images: AiUploadedImage[],
  uploadedImageAttachments: Record<string, UploadedAttachmentState>,
  uploadedFloorPlanAttachment: UploadedAttachmentState | null,
  uploadedEnergyCertificateAttachment: UploadedAttachmentState | null
) => {
  const pictureAttachments = images
    .map((image) => uploadedImageAttachments[image.id]?.attachment)
    .filter((attachment): attachment is Attachment => Boolean(attachment?.url && attachment.contentType))
    .map((attachment) => toExtractionAttachment(attachment, 'IMAGE'))

  const documentAttachments = [
    toExtractionAttachmentFromState(uploadedFloorPlanAttachment, 'FLOOR_PLAN'),
    toExtractionAttachmentFromState(uploadedEnergyCertificateAttachment, 'ENERGY_CERTIFICATE'),
  ].filter((attachment): attachment is { type: AiAttachmentType; url: string; mimeType: string } => Boolean(attachment))

  return [...pictureAttachments, ...documentAttachments]
}

const toExtractionAttachmentFromState = (attachmentState: UploadedAttachmentState | null, type: AiAttachmentType) => {
  if (!attachmentState?.attachment?.url || !attachmentState.attachment.contentType) {
    return undefined
  }

  return toExtractionAttachment(attachmentState.attachment, type)
}

const toExtractionAttachment = (attachment: Attachment, type: AiAttachmentType) => ({
  type,
  url: attachment.url!,
  mimeType: attachment.contentType!,
})
